// extracted by mini-css-extract-plugin
export default {"modal":"SelectRuleGroup_modal__d5kSE","tips":"SelectRuleGroup_tips__1jd0I","tip":"SelectRuleGroup_tip__iZ0SK"};